import {
    MOCK_HYDRATED_VIDEO,
    MOCK_HYDRATED_VERTICAL_VIDEO,
    MOCK_HYDRATED_IMAGE,
} from "~components/shared/media";
import type { Audio, Image, MagazineCoverImage, Video } from "~types/types";

export const mockVideo = ({ title }: { title: string }): Video => {
    return {
        ...MOCK_HYDRATED_VIDEO,
        autoplay: false,
        bmmrId: "f0fb39f8-47a4-46da-92d7-c014303bdbf4",
        thumbnail: {
            url: "",
        },
        title,
        url: "http://www.bloomberg.com/video.mp4",
    };
};

export const mockHydratedImage = (
    args: {
        [K in keyof Image]: Image[K];
    } = {}
): Image => {
    return {
        ...MOCK_HYDRATED_IMAGE,
        alt: "Test Alt Headline",
        baseUrl: "www.bloomberg.com/test-base-url",
        caption: "Image Caption",
        credit: "Credits for the image",
        id: "image-id",
        height: 100,
        width: 100,
        title: "Image Title",
        ...args,
    };
};

export const mockHydratedMagazineImage = ({
    index,
}: {
    index?: number;
} = {}): MagazineCoverImage => {
    return {
        ...MOCK_HYDRATED_IMAGE,
        baseUrl: `www.bloomberg.com/magazine-cover-image-${index || 1}`,
        caption: "Magazine Image Caption",
        origHeight: 100,
        origWidth: 100,
        type: "image",
    };
};

export const mockHydratedVideo = (
    args: {
        [K in keyof Video]: Video[K];
    } = {}
): Video => {
    return {
        ...MOCK_HYDRATED_VIDEO,
        aspectRatio: args.aspectRatio ?? "16:9",
        ...args,
    };
};

export const mockHydratedVerticalVideo = (
    args: {
        [K in keyof Video]: Video[K];
    } = {}
): Video => {
    return {
        ...MOCK_HYDRATED_VERTICAL_VIDEO,
        ...args,
    };
};

export const mockAudio = (
    args: {
        [K in keyof Audio]: Audio[K];
    } = { url: "http://www.bloomberg.com/audio.mp3" },
    index = 0
): Audio => {
    return {
        id: `test-avmmId-audio-${index || 1}`,
        duration: "50000",
        publishedAt: 1715899253,
        ...args,
    };
};
